import React, { FC } from 'react';
import { animated, config, useSpring } from 'react-spring';
import { FilterBar } from 'components/molecules/filter-bar';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  count: number;
  reset: () => void;
  selectAll?: () => void;
}

const Label = animated(FilterBar.Label);

export const SelectionControls: FC<Props> = ({ count, reset, selectAll }) => {
  const caption = useTranslation('task_list.bulk_editor.title', { count });
  const resetTitle = useTranslation('task_list.bulk_editor.reset');
  const selectAllTitle = useTranslation('task_list.bulk_editor.select_all');
  const style = useSpring({
    to: { scaleY: 1 },
    from: { scaleY: 0, transformOrigin: 'bottom' },
    config: config.stiff,
    loop: false,
  });

  return (
    <>
      <Label data-cy="filterbar.selected.tasks" style={style}>
        {caption}
      </Label>
      <animated.div style={style}>
        <FilterBar.Button
          ghost
          onClick={reset}
          data-cy="filterbar.button.reset"
        >
          {resetTitle}
        </FilterBar.Button>
      </animated.div>
      {selectAll ? (
        <animated.div style={style}>
          <FilterBar.Button
            ghost
            onClick={selectAll}
            data-cy="filterbar.button.selectall"
          >
            {selectAllTitle}
          </FilterBar.Button>
        </animated.div>
      ) : null}
    </>
  );
};
